function hashParams(hash = null) {
	if (hash === null) {
		hash = location.hash;
	}

	// remove # from string
	if (hash[0] === "#") {
		hash = hash.substr(1);
	}

	let params = {};

	hash.split("&").forEach(param => {
		let matches = /^([^=]+)(=(.+))?$/.exec(param);

		if (matches) {
			params[matches[1]] = matches[3] || true;
		}
	});

	return params;
}

module.exports = hashParams;